import Department from './Department.vue'
import MenuItem from "./../../../core/components/menu/MenuItem";
import i18n from '../../../shared/i18n'

let routes = [{
  path: 'departments',
  name: 'departments',
  component: Department,
  meta: {
    requiresAuth: true
  }
}];

export default {
  menuItem: new MenuItem('/departments', i18n.t('Departments'), 40, 'gavel'),
  routes: routes
}
